import Flex from "./Flex"
import Row from "./Row"
import Column from "./Column"

const Container = { Flex, Row, Column }

export default Container
